"use strict";

var _ = require("bower_components/lodash/dist/lodash.js");
var SmartBanner = require("bower_components/smart-app-banner/smart-app-banner.js");

// Module
require("core/core.module.js");
require("bower_components/ngInfiniteScroll/build/ng-infinite-scroll.min.js");
require("bower_components/angular-loading-bar/build/loading-bar.min.js");
require("node_modules/angular-chart.js/dist/angular-chart.min.js");

// CSS
require("bower_components/angular-loading-bar/build/loading-bar.min.css");
require("bower_components/smart-app-banner/smart-app-banner.css");
require("customer/scss/app.scss");
require("assets/css/lato.css");
require("assets/css/stores.css");

angular.module("customer", [
    "core",
    "infinite-scroll",
    "angular-loading-bar",
    "chart.js",
    "preventUnsavedChanges",
])

.constant("appConfig", {
    APP: "customer",
    API_SERVER: window.app.APIServer,
    ENV_NAME: window.app.ENV_NAME,
    ROOT_DOMAIN: window.app.ROOT_DOMAIN,
    ENV_SUB_DOMAIN: window.app.ENV_SUB_DOMAIN,
    ROLLBAR_ACCESS_TOKEN: window.app.ROLLBAR_ACCESS_TOKEN
});

require("APP_CONSTANT"); // Define by the build to manage white-label constante

angular.module("customer")
.config(["$locationProvider", function($locationProvider) {
    // removes angular hash (#) from urls
    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false
    });
}])
.config(function($resourceProvider) {
    $resourceProvider.defaults.stripTrailingSlashes = false;
})
.config(["cfpLoadingBarProvider", function(cfpLoadingBarProvider) {
    cfpLoadingBarProvider.parentSelector = "#loading-bar-container";
    /* TODO: WEG-82 You can specify another template
    Default templates are here: https://github.com/chieffancypants/angular-loading-bar/blob/master/src/loading-bar.js#L169-L170
    Activate the spinner here
    */
    cfpLoadingBarProvider.includeSpinner = true;
    cfpLoadingBarProvider.includeBar = true;

    cfpLoadingBarProvider.autoIncrement = true;
    cfpLoadingBarProvider.latencyThreshold = 100;
    cfpLoadingBarProvider.startSize = 0.02;
    cfpLoadingBarProvider.spinnerTemplate = "<div id=\"loading-bar-spinner-wrapper\"><div id=\"loading-bar-spinner\"><div class=\"spinner-icon\"></div></div></div>";
    cfpLoadingBarProvider.loadingBarTemplate = "<div></div>";
}])
.config(['RollbarProvider', 'appConfig', function(RollbarProvider, appConfig) {
    RollbarProvider.init({
        accessToken: appConfig.ROLLBAR_ACCESS_TOKEN,
        captureUncaught: true,
        payload: {
            environment: appConfig.ENV_NAME + " app-" + appConfig.APP
        }
    });
}])
.run(function(Rollbar, IGNORED_MESSAGES) {
    Rollbar.configure({ignoredMessages: IGNORED_MESSAGES});
})
.run(function($rootScope, appConfig) {
    var monerisMode = "qa";
    if (appConfig.ENV_NAME === "prod") {
        monerisMode = "prod";
    }
    $rootScope.MONERIS_MODE = monerisMode;
})
.run(function() {
    // clean confidential information accessibility for security purpose
    delete window.app.ENV_NAME;
    delete window.app.ROOT_DOMAIN;
    delete window.app.ENV_SUB_DOMAIN;
    delete window.app.APIServer;
    delete window.app.ROLLBAR_ACCESS_TOKEN;
})
.run(function($rootScope) {
    $rootScope.meta = {}; // initialization
})
.run(function(APP_OWNER, gettextCatalog, $rootScope) {
    // Configuration to change the title depending on the white-label
    if (APP_OWNER === "wegotrade") {
        $rootScope.meta.appTitle = "Customer - WeGoTrade";
    }
    else if (APP_OWNER === "jemangequebec") {
        $rootScope.meta.appTitle = gettextCatalog.getString("JEMANGEQUEBEC_DOCUMENT_TITLE");
        $rootScope.$on("LanguageChanged", function() {
            $rootScope.meta.appTitle = gettextCatalog.getString("JEMANGEQUEBEC_DOCUMENT_TITLE");
        });
    }
    else if (APP_OWNER === "gromec") {
        $rootScope.meta.appTitle = gettextCatalog.getString("GROMEC_DOCUMENT_TITLE");
        $rootScope.$on("LanguageChanged", function() {
            $rootScope.meta.appTitle = gettextCatalog.getString("GROMEC_DOCUMENT_TITLE");
        });
    }
    else if (APP_OWNER === "atlantis") {
        $rootScope.meta.appTitle = gettextCatalog.getString("ATLANTIS_DOCUMENT_TITLE");
        $rootScope.$on("LanguageChanged", function() {
            $rootScope.meta.appTitle = gettextCatalog.getString("ATLANTIS_DOCUMENT_TITLE");
        });
    }
    else if (APP_OWNER === "bloom") {
        $rootScope.meta.appTitle = gettextCatalog.getString("BLOOM_DOCUMENT_TITLE");
        $rootScope.$on("LanguageChanged", function() {
            $rootScope.meta.appTitle = gettextCatalog.getString("BLOOM_DOCUMENT_TITLE");
        });
    }
    // TODO WHITE_LABEL: duplicate previous IF
})

.run(function(appConfig, NavBarToggleService) {
    window.PageType = appConfig.APP;

    document.addEventListener("deviceready", function() {
        if (window.StatusBar) {
            StatusBar.styleDefault();

            if (cordova && cordova.platformId === "ios") {
                StatusBar.backgroundColorByName("white");
            }

            StatusBar.overlaysWebView(false);
            StatusBar.show();
        }
    }, false);

    NavBarToggleService.activateAutoCollapse();
})
.run(function(FlashBag) {
    FlashBag.setSuccessMessageLifetime(10000);
})
.run(["$rootScope", "$state", "$stateParams",
    function($rootScope, $state, $stateParams) {
        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;
    }
])
.run(function(gettextCatalog) {
    gettextCatalog.debug = true;
})
.run(function($window, $rootScope) {
    $rootScope.online = navigator.onLine;
    $window.addEventListener("offline", function() {
        $rootScope.$apply(function() {
            $rootScope.online = false;
        });
    }, false);

    $window.addEventListener("online", function() {
        $rootScope.$apply(function() {
            $rootScope.online = true;
        });
    }, false);
})

.controller("rootCtrl", function(
    $rootScope, $scope, Language, BrandSiteService, $state, gettextCatalog, HotjarFeedback
) {
    Language.init();
    Language.initializeScope($scope, "language", null);
    BrandSiteService.init();
    HotjarFeedback.initTrigger();

    var unregister = $rootScope.$on("UserUpdated", function(event, user) {
        unregister();
        if (typeof window.hj === "function" && user && user.username) {
            window.hj('identify', user.username, {});
        }
    });

    $rootScope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        if ($state.current.meta && $state.current.meta.title) {
            $rootScope.meta.pageTitle = $state.current.meta.title(gettextCatalog);
        }
        else {
            $rootScope.meta.pageTitle = gettextCatalog.getString("default meta title");
        }

        if (!$state.current.authenticate) {
            if ($state.current.meta && $state.current.meta.description && $state.current.meta.keywords) {
                $rootScope.meta.description = $state.current.meta.description(gettextCatalog);
                $rootScope.meta.keywords = $state.current.meta.keywords(gettextCatalog);
            }
            else {
                $rootScope.meta.description = gettextCatalog.getString("default meta description");
                $rootScope.meta.keywords = gettextCatalog.getString("default meta keywords");
            }
        }
    });
})

// TODO WEG-4 Extract in a separate file
.component("smartAppBanner", {
    controller: function($rootScope, $scope, gettextCatalog, $cookies, IS_MOBILE_APP) {
        var smartAppBanner = null;
        var unregisterLanguageChanged = $rootScope.$on("LanguageChanged", function(evt, new_locale, new_language) {
            if (smartAppBanner) {
                destroyAppBanner();
                createAppBanner();
            }
        });

        var unregister$stateChangeSuccess = $rootScope.$on("$stateChangeSuccess", function(
            event, toState, toParams, fromState, fromParams) {
            if (smartAppBanner && !isSupported()) {
                selfDestruct();
                return;
            }
            if (!toState.hideSmartBanner) {
                if (smartAppBanner) {
                    showSmartAppBanner();
                }
                else {
                    createAppBanner();
                }
            }
            else {
                hideSmartBanner();
            }
        });

        $scope.$on("$destroy", function() {
            destroyAppBanner();
            unregister$stateChangeSuccess();
            unregisterLanguageChanged();
        });

        document.addEventListener("deviceready", function() {
            selfDestruct();
        });

        function selfDestruct() {
            $scope.$destroy();
            $("smart-app-banner").remove();
        }

        function destroyAppBanner() {
            if (smartAppBanner) {
                smartAppBanner.hide();
                var bannerContainer = $(".smartbanner");
                if (bannerContainer) {
                    bannerContainer.remove();
                    smartAppBanner = null;
                }
            }
        }

        function isSupported() {
            var isDefaultBrandSite = $rootScope.brandSite && $rootScope.brandSite.default;
            return smartAppBanner.type &&
                // iOSWebviewDetection: cordova iOS webview is neither of those
                navigator.userAgent.match(/Safari|Chrome|Android/i) &&
                // As of app version 0.0.29 we added a user agent "Cordova"
                !IS_MOBILE_APP &&
                !$cookies.get("smartbanner-closed") &&
                !$cookies.get("smartbanner-installed") &&
                isDefaultBrandSite;
        }

        function createAppBanner() {
            if (!smartAppBanner) {
                smartAppBanner = new SmartBanner({
                    daysHidden: 7,
                    daysReminder: 14,
                    title: "WeGoTrade",
                    author: "WeGoTrade",
                    button: gettextCatalog.getString("View", null, "smart-app-banner download button"),
                    store: {
                        ios: gettextCatalog.getString("On the app store", null, "smart-app-banner on ios"),
                        android: gettextCatalog.getString("On the play store", null, "smart-app-banner on android")
                    },
                    price: {
                        ios: gettextCatalog.getString("Free", null, "smart-app-banner price of the app on the store"),
                        android: gettextCatalog.getString("Free", null, "smart-app-banner price of the app on the store")
                    },
                    iosAppId: "1135444079"
                });
                if (!isSupported()) {
                    selfDestruct();
                }
            }
        }

        function showSmartAppBanner() {
            if (smartAppBanner) {
                smartAppBanner.show();
            }
        }

        function hideSmartBanner() {
            if (smartAppBanner) {
                smartAppBanner.hide();
            }
        }
    }
});

require("customer/I18n.js");
require("customer/customer.route.js");

require("customer/header/header.controller.js");
require("customer/footer/footer.controller.js");
require("customer/layout/layout.directive.js");

require("customer/app-core/quantity-field/quantity-field.directive.js");
require("customer/app-core/inventory/modals/inventory-quantity.modal.js");
require("customer/app-core/inventory/inventory-quantity.component.js");
require("customer/app-core/inventory/inventory-suggested-quantity.component.js");
require("customer/app-core/ordered-quantity/modals/ordered-quantity.modal.js");
require("customer/app-core/ordered-quantity/modals/returned-quantity.modal.js");
require("customer/app-core/ordered-quantity/ordered-quantity.component.js");
require("customer/app-core/ordered-quantity/returned-quantity.component.js");
require("customer/app-core/ordered-quantity/unit-of-measure-quantity.component.js");
require("customer/app-core/custom-discounted-price/custom-discounted-price.component.js");
require("customer/app-core/preferred/preferred.service.js");
require("customer/app-core/promotion-filter/promotion-filter.service.js");
require("customer/app-core/partnership/partnership.service.js");
require("customer/app-core/vendors-list/vendor-list.directive.js");
require("customer/app-core/catalog-sharing-type/catalog-sharing-type.component.js");
require("customer/app-core/full-profile-only/full-profile-only.directive.js");
require("customer/app-core/full-profile-only/warn-incomplete-profile.directive.js");
require("customer/app-core/full-profile-only/icon-incomplete-profile.directive.js");
require("customer/app-core/information-confirmation/information-confirmation.component.js");
require("customer/app-core/deactivate-filters/deactivate-filters.component.js");
require("customer/app-core/notification/notification.service.js");
require("customer/app-core/carousel/carousel.component.js");
require("customer/app-core/community-carousel/community-carousel.component.js");
require("customer/app-core/community-carousel/community-carousel-item.directive.js");
require("customer/app-core/community-carousel/community-carousel.service.js");
require("customer/app-core/promotion-catalog-entry/promotion-catalog-entry.directive.js");
require("customer/app-core/promotion-catalog-entry/promotion-catalog-entry.service.js");
require("customer/app-core/rebate-icon/rebate-icon.component.js");
require("customer/app-core/discount-icon/discount-icon.component.js");
require("customer/app-core/mptt-category-selector/mptt-category-selector.component.js");
require("customer/app-core/mptt-category-selector/mptt-category-selector.modal.js");
require("customer/app-core/catalog-entry-price/catalog-entry-price.component.js");
require("customer/app-core/produt-preferred/product-preferred.component.js");
require("customer/app-core/invite-to-register/invite-to-register.directive.js");
require("customer/app-core/invite-to-register/invite-to-register.service.js");
require("customer/app-core/invite-to-register/banner/invite-to-register-banner.component.js");
require("customer/app-core/hotjar/hotjar-feedback.service.js");
require("customer/app-core/product-details-modal/product-details.modal.js");
require("customer/app-core/product-details-modal/product-details-modal.service.js");
require("customer/app-core/inventory-report-print-button/inventory-report-print-button.component.js");
require("customer/app-core/inventory-report-print-button/inventory-report-print-button.service.js");
require("customer/app-core/payment-methods/payment-methods.component.js");
require("customer/app-core/invoice-listing/invoice-listing.component.js");
require("customer/app-core/vendor-inventory-external-sync/vendor-inventory-external-sync.service.js");
require("customer/app-core/vendor-inventory-external-sync/vendor-inventory-external-sync.constant.js");
require("customer/app-core/sales-rep-partnership-tag-filter/sales-rep-partnership-tag.service.js");
require("core/notification/notification-list/notification-list.component.js");
require("core/notification/unread-notification-modal/unread-notification.component.js");
require("core/notification/unread-notification-modal/unread-notification.modal.js");
require("core/previous-state/previous-state.service.js");
require("core/bootstrap-helper/nav-bar-toggle.service.js");
require("core/pull-to-refresh/pull-to-refresh.directive.js");

// Constant
require("customer/app-core/vendors-list/vendor-list.constants.js");
require("core/notification/notification-list/notification-list.constants.js");
require("customer/sections/inventory-report/inventory-holder.constants.js");
require("customer/sections/user-partnership/user-partnership.constants.js");

// Controller
require("customer/sections/home/home.controller.js");
require("customer/sections/auth/registration.controller.js");
require("customer/sections/auth/quick-registration.controller.js");
require("customer/sections/auth/registration.service.js");
require("customer/sections/auth/login.controller.js");
require("customer/sections/auth/customer.controller.js");
require("customer/sections/auth/user-info.service.js");
require("customer/sections/order/order-list.controller.js");
require("customer/sections/order/order-detail.controller.js");
require("customer/sections/order/no-order-notification/no-order-notification.controller.js");
require("customer/sections/order/no-order-notification/no-order-notification.service.js");
require("customer/sections/order/no-order-notification/modals/no-order-notification.modal.js");
require("customer/sections/order/customer-order.service.js");
require("customer/sections/order/order-confirmation.controller.js");
require("customer/sections/commission/commission-list.controller.js");
require("customer/sections/commission/commission.service.js");
require("customer/sections/deposit-slip/deposit-slip-list.controller.js");
require("customer/sections/deposit-slip/deposit-slip.service.js");
require("customer/sections/invoice/invoice-list.controller.js");
require("customer/sections/invoice/invoice-detail.controller.js");
require("customer/sections/invoice/invite-owner-form.controller.js");
require("customer/sections/invoice-attachment/invoice-attachment.controller.js");
require("customer/sections/invoice-copy/invoice-copy.controller.js");
require("customer/sections/payment/payment-list.controller.js");
require("customer/sections/payment/payment-details.controller.js");
require("customer/sections/invoice-copy/unauthenticated-invoice.service.js");
require("customer/sections/payment/payment.controller.js");
require("customer/sections/stock/stock.service.js");
require("customer/sections/stock/stock.controller.js");
require("customer/sections/stock/catalog-entry/stock-product-details.modal.js");
require("customer/sections/stock/use-previous-order.modal.js");
require("customer/sections/stock/stock-listing.directive.js");
require("customer/sections/stock/catalog-entry/abstract-stock-catalog-entry.controller.js");
require("customer/sections/stock/catalog-entry/catalog-entry-list.directive.js");
require("customer/sections/stock/catalog-entry/catalog-entry-grid.directive.js");
require("customer/sections/cart/cart-item.service.js");
require("customer/sections/cart/cart-vendor.service.js");
require("customer/sections/cart/cart-item.directive.js");
require("customer/sections/cart/deposit-item.directive.js");
require("customer/sections/cart/punch-out.service.js");
require("customer/sections/cart/shopping-cart.controller.js");
require("customer/sections/notification/notification-history.controller.js");
require("customer/sections/user-customer/user-customer.service.js");
require("customer/sections/user-customer/user-customer-list.controller.js");
require("customer/sections/user-partnership/user-partnership.service.js");
require("customer/sections/user-partnership/user-partnership-list.controller.js");
require("customer/sections/user-partnership/modals/user-partnership-details.modal.js");
require("customer/sections/order-consolidation/order-consolidation.service.js");
require("customer/sections/order-consolidation/order-consolidation.controller.js");
require("customer/sections/inventory-report/inventory-report.service.js");
require("customer/sections/inventory-report/inventory-report.controller.js");
require("customer/sections/auth/external-login.controller.js");
require("customer/sections/goods-receipt/goods-receipt-list.controller.js");
require("customer/sections/goods-receipt/goods-receipt-details.controller.js");
require("customer/sections/goods-receipt/goods-receipt.service.js");
require("customer/sections/goods-receipt/goods-receipt-status.service.js");
require("customer/sections/goods-transfer/goods-transfer-list.controller.js");
require("customer/sections/goods-transfer/goods-transfer-details.controller.js");
require("customer/sections/goods-transfer/goods-transfer.service.js");
require("customer/sections/payment-settings/payment-settings.controller.js");
require("customer/sections/payment-settings/configure-pre-authorized-payment.controler.js");
require("customer/sections/user-management/user-management.service.js");
require("customer/sections/user-management/user-management-list.controller.js");
require("customer/sections/user-management/user-management-form.controller.js");
require("customer/sections/user-management/modals/owner-details.modal.js");
require("customer/sections/payment-settings/payment-settings.service.js");
require("customer/sections/order-template/order-template-list.controller.js");
require("customer/sections/order-template/order-template-details.controller.js");
require("customer/sections/order-template/order-template.service.js");
require("customer/sections/order-template/modals/standing-order-logs.modal.js");

require("customer/header/search-bar.html");
require("customer/header/sales-rep-navigation.html");
require("customer/header/web-navigation.html");
require("customer/header/mobile-navigation.html");
require("customer/header/vendor-order-manager-web-navigation.html");
require("customer/header/vendor-order-manager-mobile-navigation.html");
require("customer/header/punch-out-web-navigation.html");
require("customer/header/punch-out-mobile-navigation.html");
require("customer/header/web-navigation-without-user-agreement.html");
require("customer/header/mobile-navigation-without-user-agreement.html");
require("customer/sections/user-partnership/user-partnership-last-order-inline-filter.html");
require("customer/sections/user-partnership/user-partnership-last-invoice-inline-filter.html");
require("customer/sections/user-partnership/user-partnership-order-deadline-inline-filter.html");



//////////////////
// WEBPACK FOOTER
// ./customer/customer.module.js
// module id = 2
// module chunks = 0